<template>
  <div class="bg">
    <div class="content">
      <div class="page-header">
        <el-page-header @back="goBack"></el-page-header>
        <span id="header-title">我的历史</span>
      </div>
      <div class="main">
        <el-tabs type="card" :tab-position=" 'left' " class="tabs">
          <el-tab-pane label="检索历史">
            <div class="info">
              <el-card class="card3" :body-style="{ padding: '0px' }" shadow="never" v-for="(item, index) in searchHistory" :key="index">
                <div class="card3-main" @click="gotoDetailedInfo(item.id)" style="height:100%">
                  <div style="display:inline-block; width:20px; vertical-align:top; font-size:14px">{{index+1}}</div>
                  <div style="display:inline-block; width:calc(100% - 220px);">
                    <div class="card3-line1">
                      <div class="card3-info-item">
                        <div class="attribute-name">检索时间：</div>
                        <div class="attribute-value">{{item.time}}</div>
                      </div>
                      <div class="card3-info-item">
                        <div class="attribute-name">检索式：</div>
                        <div class="attribute-value">{{item.formula}}</div>
                      </div>
                    </div>
                    <div class="card3-line2">
                      <div class="attribute-name">检索图片：</div>
                      <div class="card3-image-container" v-for="(img,index) in item.image_array" :key="index">
                        <el-image :src=img :fit=" 'contain' " style="width:100px; height:100px">
                          <div slot="placeholder" class="image-slot" style="width:100px; height:100px">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                      </div>
                    </div>
                  </div>
                  <div style="display:inline-block; width:200px; vertical-align:middle">
                    <el-button class="text-button-1" type="text" icon="el-icon-search">重新检索</el-button>
                    <el-button class="text-button-1" type="text" icon="el-icon-delete">删除记录</el-button>
                  </div>
                </div>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane label="专利浏览记录">
            <div class="info">
              
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'account',
    data() {
      return {
        searchHistory: [
          {
            time: '2022-12-18 19:46:01',
            formula: "keyword='扫地机器人'",
            image_array: [
              "http://co.nercdh.cn:3388/searchImg/000003.jpg",
              "http://co.nercdh.cn:3388/searchImg/000004.jpg",
              "http://co.nercdh.cn:3388/searchImg/000005.jpg"
            ]
          },
          {
            time: '2022-12-18 19:46:01',
            formula: "keyword='glass'",
            image_array: []
          },
          {
            time: '2022-12-18 19:46:01',
            formula: "apply_num='CN201830128019.3'",
            image_array: [
              "http://co.nercdh.cn:3388/searchImg/000003.jpg",
              "http://co.nercdh.cn:3388/searchImg/000004.jpg",
            ]
          },
          {
            time: '2022-12-18 19:46:01',
            formula: "keyword='扫地机器人'",
            image_array: [
              "http://co.nercdh.cn:3388/searchImg/000005.jpg"
            ]
          }
        ],
        patentHistory: [
          {
            
          }
        ]
      }
    },
    methods: {
      goBack() {
        window.history.back();
      },
    }
  }
</script>

<style scoped>
  .bg {
    background-color: #f7faff;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .content{
    width: calc(100% - 400px);
    max-width: 1920px;
    height: calc(100vh - 48px);
    flex-direction: column;
    margin: 0 200px 0 200px;
  }

  .page-header {
    height: 49px;
    width: 100%;
    border-bottom: 1px solid #e5e6eb;
  }
  .el-page-header {
    padding-top: 10px;
    width: 94px;
    float: left;
  }
  .page-header #header-title {
    font-size: 18px;
    font-weight: bold;
    float: left;
    margin: 9px 40px 0 0;
  }

  .main {
    overflow: auto;
    height: calc(100% - 80px);
    width: 100%;
    padding-top: 30px;
  }
  .info {
    overflow: auto;
    background-color: #FFFFFF;
    width: calc(100% - 160px);
    padding: 0 80px 0 80px;
  }

  .image-container {
    cursor: pointer;
    width: 144px;
    height: 144px;
    padding: 0 8px 8px 8px;
    display: inline-block;
  }
  .patentData-name {
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 5px;
  }
  .attribute-name{
    display: inline-block;
    vertical-align: top;
    width: 120px;
    text-align: right;
    padding-right: 30px;
    color: #959595;
    font-weight: bold;
    font-size: 14px;
  }
  .attribute-value{
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
  }

  .card3 {
    width: calc(100% - 20px);
    padding: 40px 20px 40px 0;
    border: none;
    border-bottom: 1px solid #EBEEF5;
  }
  .card3-line1 {
    margin: 0 0 20px 0;
  }
  .card3-line2 {
    margin: 0 20px 0 0;
    overflow: hidden;
  }
  .card3-info-item {
    width: 40%;
    display: inline-block;
  }
  .card3-image-container {
    cursor: pointer;
    width: 100px;
    height: 100px;
    padding-right: 16px;
    display: inline-block;
  }
</style>
